Auth = require 'db/auth'
Controller = require 'controller'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
{ maybeDisplayOrgMemberLimitsError } = require 'views/organization/member-limits-error'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
$ = require 'jquery'

module.exports = class CreateOrgView extends View
  viewTitleKey: 'create organization'

  initialize: ({ @createOpts }) ->
    @createOpts ?= { isBusinessClass: false, boardToAddToOrg: false, isEnterprise: false }

  events:
    'click .js-save': 'submit'
    'submit form': 'submit'
    'click .js-business-class': 'clickBusinessClassMore'
    'input .js-display-name': ->
      @updateSubmitButton()

  getValue: (name) -> @$("[name=#{name}]").val()?.trim()

  render: ->
    if @createOpts.isEnterprise
      templateName = 'org_create_enterprise'
      templateArgs =
        enterprises: Auth.me().enterpriseList
    else
      templateName = 'org_create'
      templateArgs =
        boardToAddToOrg: @createOpts.boardToAddToOrg
        memberCount: @model.memberList?.length

    @$el.html(templates.fill(templateName, templateArgs))
    @updateSubmitButton()

    @

  updateSubmitButton: ->
    @$('.js-save').prop('disabled', @getValue('displayName').length == 0)

  submit: (e) ->
    Util.stop(e)
    if maybeDisplayOrgMemberLimitsError($(e.target), null, Auth.me())
       return

    data = {}

    @$('.js-save')
    .prop('disabled', true)
    .addClass('disabled')

    for name in ['displayName', 'desc', 'enterprise']
      data[name] = @getValue(name)

    Auth.me().organizationList.create data, {
      @modelCache
      silent: true
      success: (data) =>
        if @createOpts.boardToAddToOrg
          @createOpts.boardToAddToOrg.update({ idOrganization: data.id })
        ModelLoader.loadOrganizationMembersMinimal(data.id)
        .then =>
          if @$('.js-add-members').prop('checked')
            org = @model.getOrganization()
            Promise.map @model.memberList.models, (member) ->
              if !org.isMember(member)
                org.changeMemberRole(member, { type: 'normal' })
            , { concurrency: 3 }
        .then =>
          if @createOpts.isBusinessClass
            Controller.organizationBillingView(data.get('name'))
            track("New Team", "Create Business Class Team", undefined, data.id)
          else if @createOpts.isEnterprise
            Controller.organizationAccountView(data.get('name'))
            track("New Team", "Create Enterprise Team", undefined, data.id)
          else
            Controller.organizationBoardsView(data.get('name'), data.id)
            track("New Team", "Create Team", undefined, data.id)
          PopOver.hide()
          return
        .done()
    }

    return

  clickBusinessClassMore: ->
    track("New Org", "Click Business Class Link")



// WEBPACK FOOTER //
// ./app/scripts/views/organization/create-org-view.coffee